module.exports = __webpack_public_path__ + "img/66000.3c4636c3.jpg";